const { createElem } = require('./helpers');

class SideNavigation {
  constructor() {
    this.navElem = document.querySelector('.top-nav .left-nav');
    this.subMenuParents = [...document.querySelectorAll('.top-nav .has-children a')];
    this.searchElem = document.querySelector('.top-nav .search-container');
  }

  getElem(elem) {
    return elem.parentElement.removeChild(elem);
  }

  buildHtml() {
    const frag = document.createDocumentFragment();

    const navWrapper = createElem('div', { class: 'hub-nav hub-nav--wrapper' });
    const navList = this.getElem(this.navElem);
    navList.setAttribute('class', 'hub-nav--nav');
    const navSearch = this.getElem(this.searchElem);
    navSearch.classList.add('hub-nav--search');

    const searchInput = navSearch.querySelector('.search-input');
    const searchLabel = createElem('label', { class: 'visually-hidden', for: 'q' }, 'Search');
    searchInput.insertBefore(searchLabel, searchInput.firstChild);

    navWrapper.appendChild(navList);
    navWrapper.appendChild(navSearch);
    frag.appendChild(navWrapper);

    return frag;
  }

  toggleSubMenu() {
    const subMenuElement = this.parentElement.querySelector('ul');

    if (this.parentElement.classList.contains('active')) {
      this.parentElement.classList.remove('active');

      if (window.innerWidth >= 1150) {
        $(subMenuElement).slideToggle(300);
      }

    } else {
      if (window.innerWidth >= 1150) {
        $(subMenuElement).slideToggle(300);
      } else {
        const openMenu = document.querySelector(`li.active`);
        openMenu ? openMenu.classList.remove('active') : null;
      }

      this.parentElement.classList.toggle('active');
    }

    if (!this.parentElement.classList.contains('active')) {
      this.setAttribute('style', 'font-weight: 400;');
    } else {
      this.setAttribute('style', 'font-weight: 600;');
    }
  }

  closeAllSubMenus() {
    for (let i = 0; i < this.subMenuParents.length; i++) {
      const currentMenu = this.subMenuParents[i].parentElement;
      if (currentMenu.classList.contains('active')) {
        currentMenu.classList.remove('active');
        currentMenu.querySelector('ul').setAttribute('style', 'display: none;');
      }
    }
  }

  resizeListener() {
    let lastWindowWidth;

    window.addEventListener('resize', (e) => {
      const currentWindowWidth = window.innerWidth;
      if (lastWindowWidth > 1150 && currentWindowWidth < 1150) {
        this.closeAllSubMenus();
      }
      lastWindowWidth = currentWindowWidth;
    });
  }

  activeMenuListener() {
    const activeMenu = document.querySelector('.hub-nav--nav > .selected');

    setTimeout(() => {
      if (!activeMenu) {
        this.activeMenuListener();
      } else {
        activeMenu.classList.add('active');
      }
    }, 500);
  }

  clickListener() {
    for (let i = 0; i < this.subMenuParents.length; i++) {
      this.subMenuParents[i].addEventListener('click', this.toggleSubMenu);
    }
  }

  init() {
    const target = document.querySelector('.level-two');

    if (!target) {
      throw new ReferenceError('Could not append navigation');
    }

    target.insertBefore(this.buildHtml(), target.firstChild);
    this.clickListener();
    this.resizeListener();

    if (!document.querySelector('body').classList.contains('hub-page')) {
      this.activeMenuListener();
    }

    return this;
  }
}

module.exports = SideNavigation;


// WEBPACK FOOTER //
// ./modules/SideNavigation.js